<template lang="pug">
box
  page-title(slot="page-title", title="Notas recebidas")
    filter-button(
      slot="action",
      @click="$router.push('/app/notas-recebidas/filtrar')",
      :filtered="filtered"
    )
  list-manager.scrollable(
    slot="content",
    :errors="errors",
    :pages="pages",
    :page="page",
    :loading="loading",
    :next="nextPage",
    :prev="prevPage",
    :count="list.length"
  )
    router-view
    .container.grid-lg
      .columns
        .column.col-6.col-sm-12.my-2(v-for="nota in list")
          row(:nota="nota")
</template>

<script>
import listMixin, { defaultStoreImports } from "@/mixins/list";
import Row from "./Row";

export default {
  components: { Row },
  vuex: {
    notasRecebidas: defaultStoreImports,
  },
  mixins: [listMixin],
};
</script>
